<template>
  <div>
    <GDQQuestionnaire
      v-if="formerror == 0"
      api="1"
      :successurl="successurl"
    />
  </div>
</template>
<script>
import GDQQuestionnaire from './GDQQuestionnaire.vue'

export default {
  components: {
    GDQQuestionnaire
  },
  data () {
    return {
      token: this.$route.params.t ? this.$route.params.t : '',
      survey_id: this.$route.params.i ? this.$route.params.i : '',
      successurl: this.$route.query.u ? this.$route.query.u : '',
      formerror: 1
    }
  },
  created () {
    this.surveymember_get()
  },
  methods: {
    surveymember_get () {
      const filter = {
        groupsurveymember_token: {
          operator: '=',
          value: this.token
        },
        survey_id: {
          operator: '=',
          value: this.survey_id
        }
      }
      this.$store
        .dispatch('questionnaire_gdqsurveymember_fetch', { filter: filter })
        .then(resp => {
          if (resp.data.total != 1) {
            this.formerror = 1
          } else {
            this.formerror = 0
          }
        })
    }
  }
}
</script>
<style scoped></style>
